/* eslint-disable @angular-eslint/component-class-suffix */
import { CommonModule } from "@angular/common";
import {
    Component,
    computed,
    effect,
    ElementRef,
    inject,
    signal,
    viewChild,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { Icon } from "@malirang/front-share";
import { ChildStore } from "../../stores/child.store";
import { ChatbotComponent } from "./components/chatbot/chatbot.component";

@Component({
    selector: "app-my-child",
    standalone: true,
    imports: [CommonModule, RouterModule, Icon, ChatbotComponent],
    templateUrl: "./my-child.layout.html",
    styleUrl: "./my-child.layout.scss",
})
export default class MyChildLayout {
    readonly childStore = inject(ChildStore);

    children = this.childStore.children;
    tabContainer = viewChild<ElementRef<HTMLElement>>("tabContainer");

    isScrollEnd = signal(false);

    // 예시로 Vue-style Composition API 기준
    maskStyle = computed(() =>
        this.isScrollEnd()
            ? "linear-gradient(to right, transparent 0%, black 20px, black 100%)"
            : "linear-gradient(to right, transparent 0%, black 20px, black calc(100% - 52px), transparent 100%)",
    );

    myChildTabs = [
        {
            key: "dashboard",
            value: "대시보드",
            icon: "material-symbols:search",
        },
        {
            key: "info",
            value: "상세 정보",
            icon: "bi:chat-left-text-fill",
        },
        {
            key: "development-service",
            value: "서비스",
            icon: "zondicons:computer-desktop",
        },
        {
            key: "diary",
            value: "아동일지",
            icon: "ion:newspaper",
        },
        {
            key: "history",
            value: "검사내역",
            icon: "solar:pen-bold-duotone",
        },
    ];

    constructor() {
        effect((onCleanup) => {
            const container = this.tabContainer()?.nativeElement;
            if (!container) return;

            const handleScroll = () => {
                const { scrollWidth, scrollLeft, clientWidth } = container;
                this.isScrollEnd.set(
                    scrollWidth - scrollLeft <= clientWidth + 1,
                );
            };

            container.addEventListener("scroll", handleScroll);

            let isDragging = false;
            let startX: number;
            let scrollLeft: number;

            const onMouseDown = (e: MouseEvent) => {
                isDragging = true;
                startX = e.pageX - container.offsetLeft;
                scrollLeft = container.scrollLeft;
                container.style.cursor = "grabbing";
                container.style.userSelect = "none";
            };

            const onMouseLeaveOrUp = () => {
                isDragging = false;
                container.style.cursor = "grab";
                container.style.userSelect = "auto";
            };

            const onMouseMove = (e: MouseEvent) => {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.pageX - container.offsetLeft;
                const walk = (x - startX) * 2; // scroll-fast
                container.scrollLeft = scrollLeft - walk;
            };

            container.addEventListener("mousedown", onMouseDown);
            container.addEventListener("mouseleave", onMouseLeaveOrUp);
            container.addEventListener("mouseup", onMouseLeaveOrUp);
            container.addEventListener("mousemove", onMouseMove);

            // ResizeObserver로 창 크기 변경 감지
            const resizeObserver = new ResizeObserver(handleScroll);
            resizeObserver.observe(container);

            // Cleanup 함수
            onCleanup(() => {
                container.removeEventListener("scroll", handleScroll);
                container.removeEventListener("mousedown", onMouseDown);
                container.removeEventListener("mouseleave", onMouseLeaveOrUp);
                container.removeEventListener("mouseup", onMouseLeaveOrUp);
                container.removeEventListener("mousemove", onMouseMove);
                resizeObserver.disconnect();
            });
        });
    }
}
